import { Module } from "wrapper6";
import gumshoe from 'gumshoejs';

export default class Gumshoe extends Module {

	ready(app) {
        
        var GUMSHOE = document.querySelector('[data-gumshoe]');

        if (GUMSHOE) {

            gumshoe.init({
                offset: 150,
            });

        }

    }
}